var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.988,
    height: 18.988,
    viewBox: "0 0 18.988 18.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2695",
    "data-name": "Group 2695",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    d: "M2.235-.85A3.085,3.085,0,1,1-.85,2.235,3.088,3.088,0,0,1,2.235-.85Zm0,4.807A1.723,1.723,0,1,0,.512,2.235,1.725,1.725,0,0,0,2.235,3.957Z",
    transform: "translate(7.26 7.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M9.708,19.138a2.286,2.286,0,0,1-2.283-2.283v-.063a.637.637,0,0,0-.419-.58l-.04-.016a.641.641,0,0,0-.7.126l-.045.045a2.284,2.284,0,1,1-3.23-3.231l.045-.045a.638.638,0,0,0,.126-.7l0-.007a.641.641,0,0,0-.587-.388H2.433a2.283,2.283,0,0,1,0-4.567H2.5a.637.637,0,0,0,.58-.419q.007-.02.016-.04a.638.638,0,0,0-.126-.7l-.045-.045a2.284,2.284,0,1,1,3.231-3.23L6.2,3.03a.641.641,0,0,0,.7.126.681.681,0,0,1,.157-.048.641.641,0,0,0,.3-.542V2.433a2.283,2.283,0,0,1,4.567,0v.072a.64.64,0,0,0,.388.584l.007,0a.641.641,0,0,0,.7-.126l.045-.045A2.284,2.284,0,1,1,16.3,6.152l-.045.045a.638.638,0,0,0-.126.7.681.681,0,0,1,.048.157.641.641,0,0,0,.542.3h.133a2.283,2.283,0,1,1,0,4.567h-.072a.64.64,0,0,0-.584.388l0,.007a.638.638,0,0,0,.126.7l.045.045a2.284,2.284,0,1,1-3.231,3.23l-.045-.045a.641.641,0,0,0-.7-.126l-.007,0a.641.641,0,0,0-.388.587v.133A2.286,2.286,0,0,1,9.708,19.138ZM7.5,14.941a1.992,1.992,0,0,1,1.291,1.825q0,.008,0,.016v.072a.921.921,0,0,0,1.843,0v-.136a2.012,2.012,0,0,1,3.417-1.432l.005.005.048.048a.922.922,0,1,0,1.3-1.3l-.048-.048-.005-.005a2.014,2.014,0,0,1,1.43-3.417h.075a.921.921,0,0,0,0-1.843h-.136a2,2,0,0,1-1.836-1.214.681.681,0,0,1-.051-.192,1.993,1.993,0,0,1,.454-2.075l.005-.005.048-.048a.922.922,0,1,0-1.3-1.3l-.048.048-.005.005a2.014,2.014,0,0,1-3.417-1.43V2.433a.921.921,0,1,0-1.843,0V2.57A2,2,0,0,1,7.509,4.405a.681.681,0,0,1-.192.051A2,2,0,0,1,5.242,4L5.237,4l-.048-.048a.922.922,0,1,0-1.3,1.3l.048.048.005.005A1.993,1.993,0,0,1,4.347,7.5,1.992,1.992,0,0,1,2.521,8.787H2.433a.921.921,0,1,0,0,1.843H2.57A2.014,2.014,0,0,1,4,14.046L4,14.052l-.048.048a.922.922,0,1,0,1.3,1.3l.048-.048.005-.005a2,2,0,0,1,2.19-.409Z",
    transform: "translate(-0.15 -0.15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.78bda570ec31cd50580561fa0735944b.svg";
export { ForwardRef as ReactComponent };